import { Layout } from '../../queries/ats/layout/types';
import { getAspectRatio, getSectionItemImage } from '../../utils/atsLayoutUtils';
import { Image } from '../image/Image';

interface AtsImageProps extends React.ComponentProps<'img'> {
  item: Layout.SectionItem;
  pattern: Layout.Pattern;
  className?: string;
}

export function AtsImage({ item, pattern, className, src, width, ...rest }: AtsImageProps) {
  const aspectRatio = getAspectRatio(pattern);
  const image = getSectionItemImage(item, pattern, aspectRatio);

  return (
    <Image
      className={className}
      src={src || image}
      alt={item.name || item.slug}
      width={width}
      onMouseDown={(e) => e.preventDefault()}
      loading="lazy"
      preventDrag
      {...rest}
    />
  );
}
